import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { sourceKeys } from '../../data/upgradeData/properties/sources';
import UIDialogHeaderImage from 'UIComponents/dialog/UIDialogHeaderImage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import H2 from 'UIComponents/elements/headings/H2';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIList from 'UIComponents/list/UIList';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { upgradeDataPropsInterface } from '../../data/upgradeData/interfaces/upgradeDataPropsInterface';
import { openNewTab } from 'ui-addon-upgrades/_core/common/navigation/url'; // @ts-expect-error dependency missing types

import { getAcademyTrialRedirectLink } from '../../../trial/utils';
import { StyledModal } from '../StyledModal';
import { WEB_FONT_DEMI_BOLD_WEIGHT } from 'HubStyleTokens/misc';
const {
  TRIAL
} = sourceKeys;

const ActivationSuccessModal = ({
  ctaText,
  hideBackground,
  header,
  onSuccess = () => {},
  showIllustration,
  subText,
  type,
  showTrialLoadingState,
  showSubtitle,
  upgradeData: {
    app,
    upgradeProduct
  }
}) => {
  const isTrialModal = type === TRIAL;
  const academySuccessButtonProps = app === 'learning-center' ? {
    external: true,
    href: getAcademyTrialRedirectLink(upgradeProduct) // href is required only for the external icon to show up

  } : undefined;

  const onSuccessHandler = () => {
    if (app === 'learning-center') {
      openNewTab(getAcademyTrialRedirectLink(upgradeProduct));
    }

    onSuccess();
  };

  return /*#__PURE__*/_jsxs(StyledModal, {
    hideBackground: hideBackground,
    centered: true,
    size: "auto",
    use: "success",
    width: 600,
    children: [showIllustration && /*#__PURE__*/_jsx(UIDialogHeaderImage, {
      offsetBottom: -30,
      offsetTop: 40,
      children: /*#__PURE__*/_jsx(UIIllustration, {
        name: "success",
        width: 118
      })
    }), /*#__PURE__*/_jsx(UIDialogHeader, {
      className: showSubtitle ? 'p-bottom-2' : undefined,
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(H2, {
          children: header || /*#__PURE__*/_jsx(FormattedMessage, {
            message: `upgrades.activationModal.${isTrialModal ? 'trialTitle' : 'productTitle'}`
          })
        }), showSubtitle && /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx("p", {
            className: "m-top-4 m-bottom-2",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "upgrades.activationModal.trialSubtitle"
            })
          }), /*#__PURE__*/_jsx("p", {
            className: "text-center",
            style: {
              fontWeight: parseInt(WEB_FONT_DEMI_BOLD_WEIGHT, 10)
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `upgrades.products.${upgradeProduct}`
            })
          })]
        })]
      })
    }), subText && /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx("p", {
        children: subText
      })
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      align: "center",
      children: /*#__PURE__*/_jsx(UIList, {
        firstChildClassName: "m-bottom-3",
        style: {
          maxWidth: '350px'
        },
        children: showTrialLoadingState ? /*#__PURE__*/_jsx(UILoadingSpinner, {
          showLabel: true,
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.activationModal.loadingLabel"
          })
        }) : /*#__PURE__*/_jsx(UIButton, Object.assign({
          block: true,
          use: "primary",
          onClick: onSuccessHandler
        }, academySuccessButtonProps, {
          children: ctaText || /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.activationModal.getStarted"
          })
        }))
      })
    })]
  });
};

ActivationSuccessModal.defaultProps = {
  showIllustration: true,
  showSubtitle: false,
  showTrialLoadingState: false
};
ActivationSuccessModal.propTypes = Object.assign({
  ctaText: PropTypes.node,
  hideBackground: PropTypes.bool,
  header: PropTypes.node,
  onSuccess: PropTypes.func,
  showIllustration: PropTypes.bool,
  subText: PropTypes.node,
  type: PropTypes.string.isRequired,
  showTrialLoadingState: PropTypes.bool,
  showSubtitle: PropTypes.bool
}, upgradeDataPropsInterface);
export default ActivationSuccessModal;